<div class="max-w-6xl mx-auto">

  <div class="bg-white shadow rounded-lg p-6 mb-8 text-center">
    <h1 class="text-3xl font-bold mb-2">Gérer les formations</h1>
    <p class="text-gray-600">Ajouter, modifier et supprimer des formations</p>
  </div>

  <div class="bg-white shadow rounded-lg p-8">
    <h2 class="text-xl font-semibold mb-6 text-center">Ajouter une formation</h2>

    <app-formations-form
      (formSubmit)="onCreate($event)">
    </app-formations-form>

    <app-manage-formations-table></app-manage-formations-table>
  </div>

</div>

